import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react'; // @ts-expect-error Untyped import

import BadRequestError from './BadRequestError';
import Raven from 'raven-js';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }

  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, {
      extra: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      return /*#__PURE__*/_jsx(BadRequestError, {});
    }

    return this.props.children;
  }

}

export default ErrorBoundary;